export function isFree(type) {
    return type === "free" || type === "free_but";
}
export function isFilled(type) {
    return type === "filled" || type === "filled_but";
}
